import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';

/**
 * Renders a multi-select bar that exposes an `onChange` event
 * This component is Not Controlled
 */
export default class RateFilter extends React.Component {
    constructor() {
        super(...arguments);

        this.state = {
            currentValue: null
        };

        if (this.props.defaultValue && this.props.defaultValue.length) {
            let preparedValues = this.props.rates.filter(rate => this.props.defaultValue.indexOf(rate.id) > -1);
            let ratesValue = this.getRates(preparedValues);
            this.state.currentValue = ratesValue;
            this.updateFilter(ratesValue);
        }
    }

    /**
     * Triggers the exposed `onChange` event calling `this.props.onChange`
     * @param {Object} value - Value passed by select element
     * @returns {undefined}
     */
    updateFilter(value) {
        let rates = value.map(el => el.value);
        this.props.onChange(rates);
        this.setState({
            currentValue: value
        });
    }

    /**
     * Maps rates to get usable values on the select bar
     * @returns {Object[]} - Labeled rates for selec
     */
    getRates(rates) {
        return rates.map(rate => ({
            label: rate.name || rate?.rate_template?.name,
            value: rate.id
        }));
    }

    render() {
        let rates = this.getRates(this.props.rates);
        return (
            <Select clearable={false} isDisabled={this.props.disabled} isMulti={true} onChange={val => this.updateFilter(val)} options={rates} value={this.state.currentValue} />
        );
    }
}

RateFilter.defaultProps = {
    disabled: false
};

RateFilter.propTypes = {
    defaultValue: PropTypes.array,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    rates: PropTypes.array.isRequired
};
